var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.818359,
    width: 30.375,
    height: 30.375,
    rx: 15.1875,
    fill: "#A6BCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3245 11.7871L12.887 20.2246L9.05176 16.3894",
    stroke: "#1E56FF",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBig);
export default __webpack_public_path__ + "static/media/check-big.3ce0e198799e883411e46a86ca4160ba.svg";
export { ForwardRef as ReactComponent };